import { render, staticRenderFns } from "./MonthlyRevenuesPopup.vue?vue&type=template&id=c4aaadd4&scoped=true&"
import script from "./MonthlyRevenuesPopup.vue?vue&type=script&lang=js&"
export * from "./MonthlyRevenuesPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aaadd4",
  null
  
)

export default component.exports